import { getEnvironment } from './config'

export const isDevMode = () => getEnvironment() === 'localhost'

export const getDevAccounts = () => {
  const accounts = []
  for (let i = 1; ; i++) {
    const email = import.meta.env[`VITE_DEV_ACCOUNT_${i}_EMAIL`]
    const password = import.meta.env[`VITE_DEV_ACCOUNT_${i}_PASSWORD`]
    if (!email || !password) break
    accounts.push({
      id: i,
      label: import.meta.env[`VITE_DEV_ACCOUNT_${i}_LABEL`] || email,
      email,
      password
    })
  }
  return accounts
}

const cacheKey = (email) => `dev_session_${email.toLowerCase()}`

export const cacheDevSession = (email, data) => {
  if (!isDevMode()) return
  localStorage.setItem(cacheKey(email), JSON.stringify(data))
}

export const getCachedDevSession = (email) => {
  if (!isDevMode()) return null
  try {
    const raw = localStorage.getItem(cacheKey(email))
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}
